import React from 'react';

const ItensExchanges = ({ showProps, dataRequest }) => (
  <div>
    <div>
      <p> Você tem certeza que deseja trocar apenas: </p>
      <br />
      {showProps.tamanhoCamiseta && (
        <span>
          <strong> Camiseta #1 </strong>
          {' pelo tamanho '}
          <strong>
            {' '}
            {dataRequest.tamanhoCamiseta}
          </strong>
          <br />
          <br />
        </span>
      )}
      {showProps.tamanhoCamiseta2 && (
        <span>
          <strong> Camiseta #2 </strong>
          {' pelo tamanho '}
          <strong>
            {' '}
            {dataRequest.tamanhoCamiseta2}
          </strong>
          <br />
          <br />
        </span>
      )}
      {showProps.tamanhoCamiseta3 && (
        <span>
          <strong> Camiseta #2 </strong>
          {' pelo tamanho '}
          <strong>
            {' '}
            {dataRequest.tamanhoCamiseta3}
          </strong>
          <br />
          <br />
        </span>
      )}
      {showProps.tamanhoAgasalho && (
        <span>
          <strong> Agasalho </strong>
          {' pelo tamanho'}
          <strong>
            {' '}
            {dataRequest.tamanhoAgasalho}
          </strong>
          <br />
          <br />
        </span>
      )}
    </div>
  </div>
);

export default ItensExchanges;



// WEBPACK FOOTER //
// ./src/components/trades/ItensExchanges.js